import { render, staticRenderFns } from "./badInfoDetail.vue?vue&type=template&id=edc40018&scoped=true"
import script from "./badInfoDetail.vue?vue&type=script&lang=ts"
export * from "./badInfoDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc40018",
  null
  
)

export default component.exports